import React, { useEffect, useState } from "react";
import styled from "styled-components";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const ModalContainer = styled.div`
  background: white;
  width: 90%;
  max-width: 450px;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
`;

const Title = styled.h2`
  font-size: 1.25rem;
  margin-bottom: 15px;
  color: #333;
  font-weight: bold;
`;

const Content = styled.div`
  font-size: 0.95rem;
  line-height: 1.6;
  color: #666;
  margin-bottom: 25px;
  white-space: pre-wrap; // 줄바꿈 적용
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;

const Button = styled.button<{ $primary?: boolean }>`
  padding: 10px 20px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: 500;
  background: ${(props) => (props.$primary ? "#007bff" : "#eee")};
  color: ${(props) => (props.$primary ? "white" : "#333")};
`;

interface NoticeModalProps {
  storageKey: string;
}

const NoticeModal: React.FC<NoticeModalProps> = ({ storageKey }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // 이미 확인했는지 체크
    const hasSeen = localStorage.getItem(storageKey);
    if (!hasSeen) setIsOpen(true);
  }, [storageKey]);

  const handleClose = (neverShowAgain: boolean) => {
    if (neverShowAgain) {
      localStorage.setItem(storageKey, "true");
    }
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <Overlay>
      <ModalContainer>
        <Title>📍 위치기반서비스 종료 안내</Title>
        <Content>
          {`안녕하세요. 스카이클래스입니다.
그동안 이용해 주셨던 위치기반서비스가 내부 정책 변경에 따라 2026년 4월 20일부로 종료될 예정입니다.

관련하여 개인정보처리방침이 변경될 예정이오니 서비스 이용에 참고하시기 바랍니다. 그동안 이용해 주셔서 감사합니다.`}
        </Content>
        <ButtonGroup>
          <Button onClick={() => handleClose(true)}>다시 보지 않기</Button>
          <Button $primary onClick={() => handleClose(false)}>
            닫기
          </Button>
        </ButtonGroup>
      </ModalContainer>
    </Overlay>
  );
};

export default NoticeModal;
